/**
 * Mapa de navegação do painel, derivado do catálogo único de telas.
 *
 * Antes eram três listas escritas à mão — uma por papel — e o painel do
 * vendedor conhecia 8 das 29 telas. Era por isso que liberar "Financeiro" no
 * perfil não fazia nada: a permissão existia, o menu não.
 *
 * Agora os três painéis saem de `screens.js`. Quem some do menu, some por
 * PERMISSÃO (o PanelLayout filtra por `perm`), não por o painel desconhecer a
 * tela. Vive fora do PanelLayout porque a paleta de comandos (⌘K) lê a mesma
 * lista: duas cópias garantiriam divergência.
 */
import { SCREENS, PANEL_BASE, screenPath } from "./screens";

/** Agrupa as telas do papel nas seções do menu, na ordem do catálogo. */
const menuFor = (role) => {
  const sections = [];
  for (const screen of SCREENS) {
    let grupo = sections.find((s) => s.section === screen.section);
    if (!grupo) {
      grupo = { section: screen.section, items: [] };
      sections.push(grupo);
    }
    const to = screenPath(role, screen);
    grupo.items.push({
      to,
      label: screen.labelByRole?.[role] ?? screen.label,
      icon: screen.icon,
      perm: screen.perm,
      kw: screen.kw,
      // `end` só na raiz do painel: sem isso o item da home fica "ativo" em
      // toda tela do painel, porque `/vendedor` é prefixo de tudo.
      ...(to === PANEL_BASE[role] ? { end: true } : {}),
    });
  }

  return sections;
};

const MENUS = {
  admin: menuFor("admin"),
  vendedor: menuFor("vendedor"),
  balcao: menuFor("balcao"),
};

const PANEL_SUBTITLE = {
  admin: "Painel administrativo",
  vendedor: "Painel do vendedor",
  balcao: "Painel do balcão",
};

export { MENUS, PANEL_SUBTITLE };
